/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 17:00:29
 * @FilePath: /app-monorepo-projects/packages/app-share/src/services/fetch-user-info/index.ts
 */
import { AjaxConfig } from '@tencent/wsl-ajax';
import { loadWslAjaxAsync } from '@/utils/load-wslib';
import { TRPC_CALL_PATH } from '@/constants/url';
import { FetchUserInfoReq, FetchUserInfoRsp, FetchUserInfoResult } from '@/types/services/fetch-user-info';

/**
 * csr阶段获取用户信息
 * @export
 * @param
 * @return {*}  {(Promise<FetchResult | null>)}
 */
export async function fetchUserInfoCSR(params: FetchUserInfoReq): Promise<FetchUserInfoRsp['person']| null> {
  const fetchConfig: AjaxConfig = {
    url: `${TRPC_CALL_PATH}/GetUser`,
    withCredentials: true,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    responseType: 'json',
    data: JSON.stringify({
      req_header: {},
      req_body: {
        datalvl: 'ad',
        iChid: 0,
        person_id: params.personId,
      },
    }),
  };
  const wslAjax = await loadWslAjaxAsync();
  if (!wslAjax) return null;
  try {
    const { request } = wslAjax;
    const res = await request<FetchUserInfoResult>(fetchConfig);
    return res?.rsp_body?.person || null;
  } catch (err) {
    console.error('接口fetchUserInfo出现了一些问题');
  }
  return null;
}
